const init = () => {
  const fitsseyLinks = document.querySelectorAll(".js-fitssey-link");
  const fitsseyModal = document.querySelector(".js-fitssey");
  const fitsseyModalClose = document.querySelector(".js-fitssey-close");

  if (fitsseyLinks?.length && fitsseyModal) {
    fitsseyLinks.forEach((link) =>
      link.addEventListener("click", (item) => {
        item.preventDefault();
        fitsseyModal.classList.add("active");
      })
    );

    fitsseyModalClose.addEventListener("click", (item) => {
      item.preventDefault();
      fitsseyModal.classList.remove("active");
    });
  }

  const navMobileButton = document.querySelector(".js-nav-mobile-button");
  const navLinks = document.querySelectorAll(".js-nav a");
  const nav = document.querySelector(".js-nav");

  navMobileButton.addEventListener("click", (event) => {
    event.preventDefault();
    nav.classList.toggle("active");
  });

  navLinks.forEach((item) =>
    item.addEventListener("click", (event) => {
      nav.classList.remove("active");
    })
  );
};

if (document.readyState !== "loading") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
